export default {
  "HitPaw Add Music to Audio Online": "为音频添加音乐",
  "Add BGM to Audio without any difficulties.": "无压力的为音频添加背景音乐",
  "Add New": "编辑新的音频",
  "Format": "格式",
  "Add tracks": "添加轨道",
};
